export default "__VITE_ASSET__DYrNMh3U__"